<template>
  <v-footer
    dark
    height="auto"
  >
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-title class="primary darken-1 justify-center">
        <strong class="subheading"></strong>
      </v-card-title>
      <v-card-actions class="primary darken-4 justify-center">
        {{ date }} &copy; {{company}}<sup>®</sup> <strong> | CRM</strong>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>
<script>
  export default {
    data: () => ({
      date: new Date().toISOString().substr(0, 4),
      company:'Ashyaat'
    }),
    watch:{infsite(){}},
    computed:{
      infsite(){
        if(this.$store.state.user && this.$store.state.user.sitename) {
          this.company = this.$store.state.user.sitename
        }
        return this.$store.state.user
      },
    }
  }
</script>